import request from '../../utils/request'

export const getRoleOptions = (data: RequestData) => {
  return request('getRoleOptions', {
    method: 'post',
    data,
  })
}

export const getAreaOptions = (data: RequestData) => {
  return request('getAreaOptions', {
    method: 'post',
    data,
  })
}

export const getEntityOptions = (data: RequestData) => {
  return request('getEntityOptions', {
    method: 'post',
    data,
  })
}

export const queryUserList = (data: RequestData) => {
  return request('queryUserList', {
    method: 'post',
    data,
  })
}

export const querySearchRoleList = (data: RequestData) => {
  return request('getSearchRoleList', {
    method: 'post',
    data,
  })
}
